import { useCallback, useContext, useMemo } from "react";
import { IWithdrawalResponse } from "@finbackoffice/clientbff-client";
import { PixWalletDataContext } from "./pix-wallet-data.provider";

export const useSecondStepWithdrawal = () => {
    const { withdrawalData, setWithdrawalData } = useContext(PixWalletDataContext);

    const onSocketUpdate = useCallback(
        (withdrawal: IWithdrawalResponse, error: any) => {
            if (error) {
                console.error(error);
                return;
            }

            if (withdrawal.id !== withdrawalData?.id) {
                return;
            }
            setWithdrawalData({ ...withdrawalData, ...withdrawal });
        },

        [withdrawalData, setWithdrawalData],
    );

    return useMemo(
        () => ({
            onSocketUpdate,
        }),
        [onSocketUpdate],
    );
};
